import {BaseModel} from '.'

const moment = require('moment')

const registrationDateKey = 'registration'
const onlineDateKey = 'online'
const paperDateKey = 'paper'
const paymentDateKey = 'payment'
const transferDateKey = 'transfer'

/**
 * Competition model
 */
class Competition extends BaseModel {
  // Default attributes that define the "empty" state.
  defaults () {
    return {
      id: '',
      name: '',
      costs: null,
      country: null,
      public: false,
      prices: false,
      dates: null,
      testQuiz: this.getEmptyTestQuiz()
    }
  }

  loaded () {
    return this.name !== ''
  }

  title () {
    return this.loaded() ? this.name + ' ' + this.year() : ''
  }

  titleWithCountry () {
    return this.loaded() ? this.title() + ' ' + this.country : ''
  }

  year () {
    return moment(this.getOnlineDates().start).format('Y')
  }

  getRegistrationDates () {
    return this.dates ? this.dates[registrationDateKey] : null
  }

  getRegistrationStart () {
    let registrationDates = this.getRegistrationDates()
    if (registrationDates == null) {
      return null
    }

    return moment(registrationDates.start).startOf('day')
  }

  getRegistrationEnd () {
    let registrationDates = this.getRegistrationDates()
    if (registrationDates == null) {
      return null
    }

    return moment(registrationDates.end).endOf('day')
  }

  registrationStarted () {
    let start = this.getRegistrationStart()
    if (start === null) {
      return false
    }

    return moment() >= start
  }

  registrationEnded () {
    let end = this.getRegistrationEnd()
    if (end === null) {
      return false
    }

    return moment() > end
  }

  getOnlineDates () {
    return this.dates ? this.dates[onlineDateKey] : null
  }

  onlineStarted () {
    let onlineDates = this.getOnlineDates()
    if (onlineDates === null) {
      return false
    }

    return moment() >= moment(onlineDates.start).startOf('day')
  }

  onlineEnded () {
    let onlineDates = this.getOnlineDates()
    if (onlineDates === null) {
      return false
    }

    return moment() > moment(onlineDates.end).endOf('day')
  }

  transferAllowed () {
    let now = moment()
    return this.getTransferStart() <= now && this.getTransferEnd() > now
  }

  getTransferStart () {
    let paperDates = this.getPaperDates()
    if (paperDates == null) {
      return false
    }

    return moment(paperDates.start).startOf('day')
  }

  getTransferEnd () {
    return moment(this.dates[transferDateKey]).endOf('day')
  }

  transferEnded () {
    return this.getTransferEnd() <= moment()
  }

  getPaperDates () {
    return this.dates ? this.dates[paperDateKey] : null
  }

  getPaymentDate () {
    return this.dates ? this.dates[paymentDateKey] : null
  }

  isPublic () {
    return this.public
  }

  isOnline () {
    if (!this.isPublic()) {
      return false
    }

    let onlineDates = this.getOnlineDates()
    if (onlineDates === null) {
      return false
    }

    let now = moment()
    let start = moment(onlineDates['start']).startOf('day')
    let end = moment(onlineDates['end']).endOf('day')

    if (now > start && now < end) {
      return true
    }

    return false
  }

  getTestQuiz () {
    if (!this.testQuiz) {
      this.testQuiz = this.getEmptyTestQuiz()
    }

    return this.testQuiz
  }

  copyOnlineDatesToPaper () {
    this.dates.paper = {
      start: this.dates.online.start,
      end: this.dates.online.end
    }
  }

  paperDatesAsOnline () {
    let online = this.getOnlineDates()
    let paper = this.getPaperDates()
    return online.start === paper.start && online.end === paper.end
  }

  getEmptyTestQuiz () {
    return {
      id: null,
      name: '-',
      token: ''
    }
  }

  parse (data) {
    this.id = data.id
    this.name = data.name
    this.country = data.country
    this.public = data.public
    this.prices = data.prices
    this.costs = data.costs
    this.dates = data.dates

    if (data.testQuiz) {
      this.testQuiz = data.testQuiz
    }
  }

  shouldPatch () {
    return true
  }

  // Route configuration
  routes () {
    return {
      create: '/competitions',
      fetch: '/competitions/{id}',
      save: '/competitions/{id}'
    }
  }
}

export {Competition}



//////////////////
// WEBPACK FOOTER
// ./src/models/Competition.js
// module id = 882
// module chunks = 1